/* eslint-disable */

import { useEffect, useState } from "react";

import OrganisationActivityElement from "../../../ui-components/organisation-activity-element/organisation-activity-element.tsx";

import RaindropAdvertisement from "../../../ui-components/raindrop-advertisement/raindrop-advertisement.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import WaterfallActivity from "../../../ui-components/waterfall-activity/waterfall-activity.tsx";

import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import { useNavigate } from "react-router-dom";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";

import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";

import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import OrganisationSupportElement from "../../../ui-components/organisation-support-element/organisation-support-element.js";

import RaindropCardGuestMode from "../../../ui-components/raindrop-card-guest-mode/raindrop-card-guest-mode.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import { SausageStyleColor } from "../../../logic/enums.ts";
import { isProductionEnvironment } from "../../../services/environment.js";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropMotionFadeUpGroup from "../../../ui-components/raindrop-motion-fade-up-group/raindrop-motion-fade-up-group.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";

const SuggestedFriendElement = ({ id, username, presignedUrl, name }) => {
  const navigate = useNavigate();
  const [isFollowing, setIsFollowing] = useState(false);

  if (!name || !username) {
    return null;
  }

  const onFollow = (e) => {
    e.stopPropagation();
    e.preventDefault();
    fetchGraphQL(`
      mutation {
        followCreate(accountId: "${id}") {
          id
        }
      }
      `).then((result) => {
      if (result.errors) {
        console.error("RD-1129", result.errors);
        return;
      }
      setIsFollowing(true);
    });
  };
  return (
    <RaindropClickable onClick={() => navigate(`/raindrop/account/${id}`)}>
      <RaindropCard additionalClasses="flex min-w-[180px] h-full p-4 gap-4 ">
        <AccountAvatar
          isLarge={true}
          presignedUrl={presignedUrl}
          username={username}
        />
        <div className="">
          <h1 className="font-black text-xl ">{name}</h1>
          <h1 className="font-bold text-color-text-secondary">{username}</h1>
        </div>

        <div className={`${isFollowing ? "opacity-0" : ""}`}>
          <RaindropButton
            title="Follow"
            style={ButtonStyle.Secondary}
            isFluid={true}
            onClick={onFollow}
            isDisabled={isFollowing}
          />
        </div>
      </RaindropCard>
    </RaindropClickable>
  );
};

const SuggestedFriendsPanel = ({ friends }) => {
  if (!friends) {
    return null;
  }

  if (friends.length === 0) {
    return null;
  }

  return (
    <RaindropMotionFadeUp>
      <div className="flex flex-col w-full gap-2">
        <RaindropTextHeading1 className="px-4">
          Suggested friends
        </RaindropTextHeading1>
        <div className="flex flex-row gap-2 w-full overflow-x-auto no-scrollbar px-4">
          {friends.map((friend, i) => (
            <SuggestedFriendElement
              key={i}
              id={friend.id}
              username={friend.username}
              presignedUrl={friend.presignedUrl}
              name={friend.name}
            />
          ))}
        </div>
      </div>
    </RaindropMotionFadeUp>
  );
};

const CardSuggestedEntities = ({
  suggestedSearchObjects,
  values,
  setValues,
  onAddNewOrganisation,
  onCancelOrganisation,
}) => {
  if (suggestedSearchObjects === null) {
    return null;
  }

  let showCard = values.every((value) => {
    return suggestedSearchObjects.some((suggested) => {
      if (suggested.id === value.organisation?.id) {
        return true;
      }
      return false;
    });
  });

  if (!showCard) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 w-full px-4">
      <RaindropCard>
        <div className="flex flex-col w-full">
          <RaindropTextHeading1>
            Want to know where to start?
          </RaindropTextHeading1>
          <RaindropTextSubtitle>
            Use the Search Tab to find more organisations
          </RaindropTextSubtitle>
        </div>
        <div className="flex flex-col w-full gap-2">
          {suggestedSearchObjects.map((item) => (
            <OrganisationSupportElement
              key={item.id}
              organisation={item}
              values={values}
              setValues={setValues}
              showSupportButton={true}
              onAddNewOrganisation={onAddNewOrganisation}
              onCancelOrganisation={onCancelOrganisation}
            />
          ))}
        </div>
      </RaindropCard>
    </div>
  );
};

const WrapperActivityComponent = ({
  activity,
  setCurrentModalComponent = (x) => {},
}) => {
  if (activity.__typename === "OrganisationActivityType") {
    return (
      <div className="w-full px-4">
        <OrganisationActivityElement
          key={activity.id}
          organisationId={activity.organisation.id}
          organisationPresignedUrl={activity.organisation.presignedUrlLogo}
          organisationName={activity.organisation.name}
          text={activity.heading}
          externalUrl={activity.externalUrl}
          createdAt={activity.createdAt}
        />
      </div>
    );
  }

  return (
    <div className="w-full px-4">
      <WaterfallActivity
        key={activity.id}
        waterfallPostId={activity.id}
        waterfallId={activity.waterfall.id}
        waterfallTitle={activity.waterfall.title}
        urlActivity={activity.mediaObjects[0].presignedUrl}
        urlOrganisation={activity.waterfall.organisation.presignedUrlLogo}
        urlUser={activity.waterfall.account.presignedUrl}
        activityDescription={activity.text}
        username={activity.waterfall.account.username}
        createdAt={activity.createdAt}
        numberOfLikes={activity.numberOfLikes}
        hasLiked={activity.hasLiked}
        accountObjectsLiked={activity.accountObjectsLiked}
        setCurrentModalComponent={setCurrentModalComponent}
      />
    </div>
  );
};

const SuggestedPostsTitle = () => {
  return (
    <div className="flex flex-row gap-6 w-full items-center px-12 py-6">
      <div className="w-full rounded-full  h-1 dark:bg-color-dark-background-tertiary bg-color-background-tertiary" />
      <div className=" font-black whitespace-nowrap dark:text-color-dark-text-secondary text-color-text-secondary uppercase text-sm">
        Suggested Posts
      </div>
      <div className="w-full rounded-full  h-1 dark:bg-color-dark-background-tertiary bg-color-background-tertiary" />
    </div>
  );
};

const RecentlyUpdatedSection = ({ accountObjects }) => {
  if (!accountObjects) {
    return null;
  }

  const navigate = useNavigate();

  const AccountWithCircle = ({
    id,
    sausageObjects,
    presignedUrl,
    username,
    name,
    accountAwardFeaturedSlug,
  }) => {
    if (!sausageObjects) {
      return null;
    }

    const sausageValues = sausageObjects.map((sausageObject) => {
      return {
        id: sausageObject.id,
        organisation: sausageObject.organisation,
        waterfall: sausageObject.waterfall,
        value: sausageObject.percentage,
        oldValue: sausageObject.percentage,
        selected: false,
        color: sausageObject?.styleColor,
        oldColor: sausageObject?.styleColor,
      };
    });

    return (
      <RaindropClickable
        onClick={() => {
          navigate(`/raindrop/account/${id}`);
        }}
      >
        <RaindropCard>
          <FlexCol>
            <RaindropCircle
              size="XSMALL"
              id={"circle-" + id}
              sausageValues={sausageValues}
              accountAwardFeaturedSlug={accountAwardFeaturedSlug}
            />

            <FlexRow>
              <AccountAvatar
                isSmall={true}
                presignedUrl={presignedUrl}
                username={username}
              />
              <FlexCol tailwindGap="gap-0">
                <RaindropTextHeading1 className="w-full translate-y-1">
                  {name}
                </RaindropTextHeading1>
                <RaindropTextSubtitle className="w-full">
                  {username}
                </RaindropTextSubtitle>
              </FlexCol>
            </FlexRow>
          </FlexCol>
        </RaindropCard>
      </RaindropClickable>
    );
  };

  return (
    <FlexCol>
      <RaindropTextHeading1 className="w-full px-4">
        Recently updated
      </RaindropTextHeading1>
      <FlexRow
        className="px-4 overflow-x-scroll no-scrollbar "
        tailwindGap="gap-4"
      >
        {accountObjects.map((account) => (
          <AccountWithCircle
            key={account.id}
            id={account.id}
            sausageObjects={account?.accountPlan?.sausages}
            presignedUrl={account?.presignedUrl}
            username={account?.username}
            name={account?.name}
            accountAwardFeaturedSlug={account.accountAwardFeatured?.award?.slug}
          />
        ))}
      </FlexRow>
    </FlexCol>
  );
};

const DailyQuizPanel = ({ hasCompletedQuizToday = false }) => {
  return (
    <RaindropMotionFadeUp className="w-full">
      <div className="flex w-full px-4">
        <RaindropCard style={RaindropCardStyle.Gradient}>
          <div className="flex flex-col gap-4 w-full text-left ">
            <h4 className="font-black text-color-dark-text-primary text-2xl">
              Raindrop Daily Quiz
            </h4>
            <h6 className="font-bold text-color-dark-text-primary opacity-70">
              Want to feel smart again?
            </h6>
            <div className="flex w-full items-end justify-end">
              {!hasCompletedQuizToday && (
                <RaindropButton
                  title="Take the quiz"
                  to="/raindrop/bombshell"
                  icon="fa-fire"
                />
              )}
              {hasCompletedQuizToday && (
                <div className="flex flex-row items-center gap-2 text-color-dark-text-primary opacity-70">
                  <i className="fa-solid fa-fire " />
                  <h6 className="font-bold  ">Completed</h6>
                </div>
              )}
            </div>
          </div>
        </RaindropCard>
      </div>
    </RaindropMotionFadeUp>
  );
};

const RaindropActivity = ({
  userCurrent,
  values,
  setValues,
  onAddNewOrganisation,
  onCancelOrganisation,
  setCurrentModalComponent = (x) => {},
}) => {
  const navigate = useNavigate();
  const [activities, setActivites] = useState<object[] | null>(null);
  const [suggestedActivities, setSuggestedActivities] = useState<
    object[] | null
  >(null);
  const [suggestedSearchObjects, setSuggestedSearchObjects] = useState(null);

  const [recentlyUpdatedAccountObjects, setRecentlyUpdatedAccountObjects] =
    useState(null);

  const [currentAdvertisement, setCurrentAdvertisement] = useState(null);
  const [suggestedFriends, setSuggestedFriends] = useState(null);

  const [componentList, setComponentList] = useState<JSX.Element[]>([]);

  const isNoActivity = activities === null || activities.length === 0;

  const isAnonymous = userCurrent === null;

  const doShowAdvertisement =
    !isAnonymous && !isNoActivity && currentAdvertisement !== null;

  const fetchGraphQLActivityObjects = ({ isSuggested = false }) => {
    return fetchGraphQL(
      `
      query {
        activityObjects (isSuggested: ${isSuggested}) {
          __typename
          ... on OrganisationActivityType {
            id
            heading
            externalUrl
            createdAt
            organisation {
              id
              presignedUrlLogo
              name
            }
          }
          ... on WaterfallPostType {
            id
            text
            createdAt
            numberOfLikes
            hasLiked
            mediaObjects {
              presignedUrl
            }
            accountObjectsLiked {
              id
              presignedUrl
              username
            }
            waterfall {
              id
              title
              summary
              organisation {
                presignedUrlLogo
              }
              account {
                id
                presignedUrl
                username
              }
            }
          }
        }
        advertisement {
          id
          organisation {
            id
            name
            presignedUrlLogo
          }
          media {
            id
            presignedUrl
          }
        }
      }
    `,
      true
    );
  };

  // fetch the activities and advertisement
  useEffect(() => {
    fetchGraphQLActivityObjects({})
      .then((result) => {
        setActivites(result.data.activityObjects);
        setCurrentAdvertisement(result.data.advertisement);
      })
      .catch((e) => {
        console.error("RD-1129", e);
      });
  }, []);

  // fetch the suggested activities
  useEffect(() => {
    fetchGraphQLActivityObjects({ isSuggested: true })
      .then((result) => {
        setSuggestedActivities(result.data.activityObjects);
      })
      .catch((e) => {
        console.error("RD-1221", e);
      });
  }, []);

  // fetch the suggested friends and organisations
  useEffect(() => {
    fetchGraphQL(`
      query {
        accountObjectsSuggested {
          id
          username
          presignedUrl
          name
        }
        searchObjects(limit: 3) {
          __typename
          ... on OrganisationType {
            id
            name
            presignedUrlLogo
          }
          ... on WaterfallType {
            id
            title
            
            organisation {
              presignedUrlLogo
            }
            account {
              presignedUrl
            }
          }
        }
      }
      `).then((result) => {
      setSuggestedFriends(result.data.accountObjectsSuggested);
      setSuggestedSearchObjects(result.data?.searchObjects);
    });
  }, []);

  // fetch recently updated accounts
  useEffect(() => {
    fetchGraphQL(`
      query {
        accountObjectsEngaged(
          limit: 10
        ) {
          id
          name
          accountAwardFeatured {
            award {
              slug
            }
          }
          username
          presignedUrl
          accountPlan {
            id
            isPaused
            isSupportingRaindrop
            sausages {
              id
              percentage
              styleColor
              organisation {
                id
                name
                presignedUrlLogo
                isHydrated
              }
              waterfall {
                id
                title
                organisation {
                  id
                  presignedUrlLogo
                }
                account {
                  id
                  presignedUrl
                }
              }
            }
          }

        }
      }
  `).then((response) => {
      if (response.errors) {
        console.log(response.errors);
        return;
      }
      setRecentlyUpdatedAccountObjects(response.data.accountObjectsEngaged);
    });
  }, []);

  // set values to not be selected
  useEffect(() => {
    if (values === null) {
      return;
    }
    if (values.every((value) => value.selected === false)) {
      return;
    }
    const newValues = [...values];
    newValues.forEach((value) => {
      value.selected = false;
    });
    setValues(newValues);
  }, [values]);

  // Generate the component list
  useEffect(() => {
    setComponentList(() => {
      const newList: JSX.Element[] = [];

      // Add Guest Mode Panel
      if (isAnonymous) {
        newList.push(<RaindropCardGuestMode isAnonymous={isAnonymous} />);
      }

      // Add Daily Quiz Panel
      newList.push(
        <DailyQuizPanel
          hasCompletedQuizToday={
            userCurrent?.account?.streak?.hasCompletedQuizToday
          }
        />
      );

      // Add WaterfallActivty and OrganisationActivities
      if (activities) {
        newList.push(
          ...activities.map((activity) => (
            <WrapperActivityComponent
              activity={activity}
              setCurrentModalComponent={setCurrentModalComponent}
            />
          ))
        );
      }

      // Add Suggested activities
      if (suggestedActivities) {
        newList.push(<SuggestedPostsTitle />);
        newList.push(
          ...suggestedActivities.map((activity) => (
            <WrapperActivityComponent
              activity={activity}
              setCurrentModalComponent={setCurrentModalComponent}
            />
          ))
        );
      }

      // Add Suggested Entities Panel
      if (suggestedSearchObjects) {
        newList.push(
          <CardSuggestedEntities
            suggestedSearchObjects={suggestedSearchObjects}
            setValues={setValues}
            values={values}
            onAddNewOrganisation={onAddNewOrganisation}
            onCancelOrganisation={onCancelOrganisation}
          />
        );
      }

      // Add Suggested Friends Panel
      if (suggestedFriends) {
        newList.splice(
          4,
          0,
          <SuggestedFriendsPanel friends={suggestedFriends} />
        );
      }

      // Add Recently Updated Panel
      if (recentlyUpdatedAccountObjects) {
        newList.splice(
          9,
          0,
          <RecentlyUpdatedSection
            accountObjects={recentlyUpdatedAccountObjects}
          />
        );
      }

      // Add advertisements
      if (doShowAdvertisement) {
        newList.push(
          <div className="px-4 w-full">
            <RaindropAdvertisement
              organisationId={currentAdvertisement?.organisation?.id}
              organisationName={currentAdvertisement?.organisation?.name}
              organisationSrc={
                currentAdvertisement?.organisation?.presignedUrlLogo
              }
              advertisementSrc={currentAdvertisement?.media?.presignedUrl}
              isShowingButton={false}
              onClickGeneral={() => {
                navigate(
                  `/raindrop/organisation/${currentAdvertisement.organisation.id}`
                );
              }}
            />
          </div>
        );
      }

      return newList;
    });
  }, [
    activities,
    suggestedFriends,
    suggestedActivities,
    suggestedSearchObjects,
    recentlyUpdatedAccountObjects,
  ]);

  const showPageData = activities || suggestedActivities;

  return (
    <RaindropPage isFullX={true}>
      <div className="flex xl:hidden">
        <RaindropCircle
          sausageValues={values}
          size={"SMALL"}
          isRaindropPlus={userCurrent?.account?.isRaindropPlus}
          isPaused={userCurrent?.account?.accountPlan?.isPaused}
          accountAwardFeaturedSlug={
            userCurrent?.account?.accountAwardFeatured?.award?.slug
          }
        />
      </div>
      {showPageData && (
        <FlexCol>
          <RaindropMotionFadeUpGroup>{componentList}</RaindropMotionFadeUpGroup>
        </FlexCol>
      )}
    </RaindropPage>
  );
};

export default RaindropActivity;
